module.exports = __webpack_public_path__ + "asset/image-hero-screenshot-e7146bb93aeb0568.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/hero-screenshot.png
// module id = PeML
// module chunks = 1